import React from 'react';

import { Tag, Typography } from 'antd';

import { fieldIsBlock, FieldsActionBR, FieldsNameBR } from '../../constants';
import type { ChangeLogHistory, ChangeLogHistoryItemValue } from '../../constants';
import formatHistoryInfo from '../formatters';

type HistoryDetailsItemsSubFields = {
  history: ChangeLogHistory;
};

function HistoryDetailsItemsSubFields({ history }: HistoryDetailsItemsSubFields) {
  const { field, values } = history;

  const fieldHasBooleanValue = typeof field === 'boolean';

  return (
    <>
      {values.map(change => {
        const changeAlias = change.alias;
        const changeValues = change.values;

        const getValueItem = (item: ChangeLogHistoryItemValue) => {
          const haveOnlyTo = item.action === 'add';
          const showFrom = !fieldHasBooleanValue || !haveOnlyTo;
          const showTo = !fieldHasBooleanValue;

          return (
            <div
              className='flex data-[block=true]:flex-col max-sm:flex-col [&>div]:flex [&>div]:items-center'
              data-block={fieldIsBlock.includes(field)}
              key={field}
            >
              <div>
                <Tag color='warning'>{FieldsActionBR[item.action]}</Tag>
              </div>
              <div>
                <Typography.Text>{FieldsNameBR[item.field as keyof typeof FieldsNameBR]}</Typography.Text>
              </div>
              {showFrom && (
                <div>
                  <Typography.Text delete type='secondary' className='[line-break:anywhere] [&_img]:opacity-50'>
                    {formatHistoryInfo(item.field, item.from)}
                  </Typography.Text>
                </div>
              )}
              {showTo && (
                <div>
                  <Typography.Text className='[line-break:anywhere]'>
                    {formatHistoryInfo(item.field, item.to)}
                  </Typography.Text>
                </div>
              )}
            </div>
          );
        };

        return (
          <div key={field} className='w-full'>
            <div className='flex flex-col [&_p]:p-1 [&:not(:last-child)]:pb-6'>
              <div className='grow'>
                <Typography.Text>
                  {changeAlias ?? FieldsNameBR[field as keyof typeof FieldsNameBR]}
                  {!!history?.status && ` - ${history.status}`}
                </Typography.Text>
              </div>
              {changeValues.map(changeValue => getValueItem(changeValue))}
            </div>
          </div>
        );
      })}
    </>
  );
}

export default HistoryDetailsItemsSubFields;
